import { TokenController } from '../Auth';
import { AuthPersistenceStorage } from './TokenStorage';

export const auth = new TokenController(
  { basePath: process.env.BACKEND_URL },
  new AuthPersistenceStorage(),
);
